import { deleteDownloadedAttachmentsForIdentity } from '../attachments/localStorage';
import { deleteCallHistoryForIdentity } from '../callHistory/storage';
import { deleteReceivedDirectFilesForIdentity } from '../directFileTransfer/storage';
import { deleteDirectChatKey } from '../directChats/storage';
import { deleteGroupChatLocalData, getGroupChats } from '../groupChats/storage';
import { deleteHistorySecretRecordsForIdentity } from '../historySecrets/storage';
import { clearArchiveCacheForIdentity } from '../messageArchive/cache';
import { deleteMessageArchiveKeyRecordsForIdentity } from '../messageArchive/keyStore';
import { deleteMessageArchiveWriterCheckpointsForIdentity } from '../messageArchive/storage';
import {
  buildThreadKey,
  deleteIdentityMessages,
  getThreadMessagesPage,
  getThreadSummariesPage
} from '../messages/storage';
import { deleteSystemEventsForIdentity } from '../systemEvents/storage';

export async function clearLocalCircleData(params: {
  identityId: string;
  serverId?: string | null;
  serverUrl?: string | null;
}): Promise<void> {
  const identityId = params.identityId.trim();
  if (!identityId) return;

  const directThreads = (await getThreadSummariesPage({ limit: 100000 })).summaries
    .filter((summary) => summary.participantA === identityId || summary.participantB === identityId);
  for (const summary of directThreads) {
    const peerId = summary.participantA === identityId ? summary.participantB : summary.participantA;
    const page = await getThreadMessagesPage(buildThreadKey(identityId, peerId), { limit: 100000 });
    const epochs = new Set(page.messages.map((message) => message.epoch).filter((epoch): epoch is number => typeof epoch === 'number'));
    for (const epoch of epochs) {
      await deleteDirectChatKey(buildThreadKey(identityId, peerId), epoch);
    }
  }

  const groupChats = (await getGroupChats()).filter((chat) => chat.localIdentityId === identityId);
  await Promise.all(groupChats.map((chat) => deleteGroupChatLocalData(chat.chatId, chat.keyEpoch)));
  await Promise.all([
    deleteIdentityMessages(identityId),
    deleteCallHistoryForIdentity({
      identityId,
      serverId: params.serverId,
      serverUrl: params.serverUrl
    }),
    deleteSystemEventsForIdentity(identityId),
    deleteDownloadedAttachmentsForIdentity(identityId),
    deleteReceivedDirectFilesForIdentity(identityId),
    deleteHistorySecretRecordsForIdentity(identityId)
  ]);

  await Promise.all([
    clearArchiveCacheForIdentity(identityId),
    deleteMessageArchiveWriterCheckpointsForIdentity(identityId),
    deleteMessageArchiveKeyRecordsForIdentity(identityId)
  ]);
}
